import { toast } from 'react-toastify';
import { Show } from '@components/Show';
import { useEntityStore } from '@ContractBuilder/store';
import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { useToggle } from '@hooks/useToggle';
import { withPPLGuard } from '@utils/ppl-guard';
import { get } from 'lodash-es';

import { useSyncData } from '../hooks/useSyncData';
import { SyncDataButton } from '../views/SyncDataButton';
import { SyncDataDebugger } from '../views/SyncDataDebugger';
import { SyncDataModal } from '../views/SyncDataModal';

const SyncDataButtonController = () => {
  const { submission, reloadSubmission } = useEntityStore(({ submission, reloadSubmission }) => ({
    submission,
    reloadSubmission,
  }));
  const isDirty = useDatapointsStore(({ isDirty }) => isDirty);

  const getFeatureFlagState = useFeatureFlags();
  const isPPLTestEnv = getFeatureFlagState('isPPLTestEnv');

  const [isOpen, handleOpen, handleClose] = useToggle(false);
  const { onSync, isLoading, data } = useSyncData({
    onCloseWhenSuccess: handleClose,
    onOpen: handleOpen,
    reloadSubmission,
  });

  const handleConfirm = async (keepLocal?: boolean) => {
    toast.dismiss();
    await onSync(keepLocal);
    handleClose();
  };

  const lastSyncedAt = get(submission, 'last_synced_at', submission?.created_at);
  const syncStatus = submission?.is_pending_sync ? undefined : data?.message;

  return (
    <>
      <SyncDataButton
        isDisabled={isDirty}
        isLoading={isLoading}
        lastSyncedAt={lastSyncedAt}
        onClick={handleConfirm}
        syncStatus={syncStatus}
      />
      <SyncDataModal isOpen={isOpen} isLoading={isLoading} onClose={handleClose} onConfirm={handleConfirm} />
      <Show when={isPPLTestEnv}>
        <SyncDataDebugger />
      </Show>
    </>
  );
};

export default withPPLGuard(SyncDataButtonController);
